module.exports = __webpack_public_path__ + "img/LISA_Pathfinder_team.69654e1b.jpg";